// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2l_q3","savePackageButton":"ClientWallet_savePackageButton__3rgoD"};